import * as React from 'react';

import { setLocation } from 'js/lib/coursera.redirect';

import { useEnterpriseLearningPathPageData } from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathContext';
import {
  useIsSkillPathwayLoading,
  useSkillPathway,
} from 'bundles/enterprise-learning-path-description-page/contexts/SkillPathwayContext';
import EnterpriseLearningPathPageRoot from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageRoot';
import EnterpriseSkillPathwayPageRoot from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseSkillPathwayPageRoot';
import EnterpriseLearningPathPageDirectorDataProvider from 'bundles/enterprise-learning-path-description-page/providers/pages/EnterpriseLearningPathPageDirectorDataProvider';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import shouldShowSkillPathways from 'bundles/unified-home-common/utils/shouldShowSkillPathways';

export const EnterpriseLearningPathPageDirector = () => {
  const program = useProgram();
  const skillPathway = useSkillPathway();
  const isSkillPathwayLoading = useIsSkillPathwayLoading();
  const learningPath = useEnterpriseLearningPathPageData();

  // Redirect to program home page if learner should not see skill pathways.
  if (!isSkillPathwayLoading && skillPathway && !shouldShowSkillPathways(program?.id)) {
    setLocation(`/programs/${program?.metadata.slug}`);

    return null;
  }

  // If skill pathway returns data for learning path whose slug is in URL
  // the learning path is considered a "skill pathway" and we should render the skill pathway page.
  // TODO https://coursera.atlassian.net/browse/HOME-3969: Remove temp test once actual skill pathways are created.
  if (!isSkillPathwayLoading && skillPathway) {
    return <EnterpriseSkillPathwayPageRoot />;
  } else if (learningPath && !isSkillPathwayLoading && !skillPathway) {
    return <EnterpriseLearningPathPageRoot />;
  } else {
    return null;
  }
};

const EnterpriseLearningPathPageDirectorRoot = () => {
  return (
    <EnterpriseLearningPathPageDirectorDataProvider>
      <EnterpriseLearningPathPageDirector />
    </EnterpriseLearningPathPageDirectorDataProvider>
  );
};

export default EnterpriseLearningPathPageDirectorRoot;
